DJ.addBehavior('js-story-slider', '.js-story-slider', {
  attach: function(context, settings, behavior) {
    $ = jQuery;

    const $this = $(this);
    const $parent = $this.closest('.story-block');

    $this.not('.slick-initialized').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      arrows: true,
      dots: true,
      speed: 300,
      centerPadding: '0',
      infinite: true,
      draggable: false,

      prevArrow: $parent.find('.slick-prev'),
      nextArrow: $parent.find('.slick-next'),

      responsive: [
        {
          breakpoint: 974,
          settings: {
            draggable: true,
            centerPadding: '15px',
            slidesToShow: 1,
          }
        }
      ]
    });
  },



  detach: function(context, settings) {}
});
